import { LazyLoadUtils } from "../../utils/index.js";

export const SettingsMobile = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "settings/mobile/settings" */
      "./Settings.mobile.MenuItem.js"
    ),
  { componentName: "SettingsMobile" }
);

export const SettingsPC = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "settings/pc/settings.header" */
      "./Settings.pc.HeaderItem.js"
    ),
  { componentName: "SettingsPC" }
);
